type Props = {
  label?: string;
  id?: string;
  color?: string;
  checked?: boolean;
  onClick: (checked: boolean) => void;
};

export default function Switch({
  label = "",
  id = "",
  color="",
  checked = false,
  onClick,
}: Props) {
  const clickHandle = () => {
    onClick(!checked);
  };
  return (
    <div className="relative flex cursor-pointer flex-col items-center" id={id}>
      <p id={`${id}_label`} style={{ color: color }} className="text-xl">
        {label}
      </p>
      <div
        style={{ background: checked ? color : "#D1D5DB" }}
        className={`mx-2 inline-block h-5 w-10 cursor-pointer rounded-full ${
          checked ? "" : "bg-gray-300"
        }`}
        onClick={clickHandle}
      >
        <div
          className={`h-5 w-5 rounded-full bg-white ${
            checked ? "ml-5" : "mr-5"
          }`}
        ></div>
      </div>
    </div>
  );
}
